/* tslint:disable */
/* eslint-disable */
/**
 * Serveur FPS
 * Le serveur FPS permet de créer consulter et modifier des FPS
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetNumberBis'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'specialPlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postOfficeBoxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressSubRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLocality': string;
    /**
     * 
     * @type {Country}
     * @memberof Address
     */
    'addressCountry'?: Country;
}
/**
 * 
 * @export
 * @interface AddressIndebted
 */
export interface AddressIndebted {
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'streetNumberBis'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'streetType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'streetName': string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'specialPlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'postOfficeBoxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'addressSubRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'addressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebted
     */
    'addressLocality': string;
    /**
     * 
     * @type {Country}
     * @memberof AddressIndebted
     */
    'addressCountry'?: Country;
}
/**
 * 
 * @export
 * @interface AddressIndebtedOrganization
 */
export interface AddressIndebtedOrganization {
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'streetNumberBis'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'streetType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'streetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'specialPlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'postOfficeBoxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'postalCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'addressSubRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'addressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressIndebtedOrganization
     */
    'addressLocality': string;
    /**
     * 
     * @type {Country}
     * @memberof AddressIndebtedOrganization
     */
    'addressCountry'?: Country;
}
/**
 * 
 * @export
 * @interface AddressOrganization
 */
export interface AddressOrganization {
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'streetNumberBis'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'streetType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'streetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'specialPlace'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'postOfficeBoxNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'addressSubRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'addressRegion'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressOrganization
     */
    'addressLocality'?: string;
    /**
     * 
     * @type {Country}
     * @memberof AddressOrganization
     */
    'addressCountry'?: Country;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Country = {
    AD: 'AD',
    AE: 'AE',
    AF: 'AF',
    AG: 'AG',
    AI: 'AI',
    AL: 'AL',
    AM: 'AM',
    AO: 'AO',
    AQ: 'AQ',
    AR: 'AR',
    AS: 'AS',
    AT: 'AT',
    AU: 'AU',
    AW: 'AW',
    AZ: 'AZ',
    BA: 'BA',
    BB: 'BB',
    BD: 'BD',
    BE: 'BE',
    BF: 'BF',
    BG: 'BG',
    BH: 'BH',
    BI: 'BI',
    BJ: 'BJ',
    BL: 'BL',
    BM: 'BM',
    BN: 'BN',
    BO: 'BO',
    BQ: 'BQ',
    BR: 'BR',
    BS: 'BS',
    BT: 'BT',
    BV: 'BV',
    BW: 'BW',
    BY: 'BY',
    BZ: 'BZ',
    CA: 'CA',
    CC: 'CC',
    CD: 'CD',
    CF: 'CF',
    CG: 'CG',
    CH: 'CH',
    CI: 'CI',
    CK: 'CK',
    CL: 'CL',
    CM: 'CM',
    CN: 'CN',
    CO: 'CO',
    CR: 'CR',
    CU: 'CU',
    CV: 'CV',
    CW: 'CW',
    CX: 'CX',
    CY: 'CY',
    CZ: 'CZ',
    DE: 'DE',
    DJ: 'DJ',
    DK: 'DK',
    DM: 'DM',
    DO: 'DO',
    DZ: 'DZ',
    EC: 'EC',
    EE: 'EE',
    EG: 'EG',
    EH: 'EH',
    ER: 'ER',
    ES: 'ES',
    ET: 'ET',
    FI: 'FI',
    FJ: 'FJ',
    FK: 'FK',
    FM: 'FM',
    FO: 'FO',
    FR: 'FR',
    GA: 'GA',
    GB: 'GB',
    GD: 'GD',
    GE: 'GE',
    GF: 'GF',
    GG: 'GG',
    GH: 'GH',
    GI: 'GI',
    GL: 'GL',
    GM: 'GM',
    GN: 'GN',
    GP: 'GP',
    GQ: 'GQ',
    GR: 'GR',
    GS: 'GS',
    GT: 'GT',
    GU: 'GU',
    GW: 'GW',
    GY: 'GY',
    HK: 'HK',
    HM: 'HM',
    HN: 'HN',
    HR: 'HR',
    HT: 'HT',
    HU: 'HU',
    ID: 'ID',
    IE: 'IE',
    IL: 'IL',
    IM: 'IM',
    IN: 'IN',
    IO: 'IO',
    IQ: 'IQ',
    IR: 'IR',
    IS: 'IS',
    IT: 'IT',
    JE: 'JE',
    JM: 'JM',
    JO: 'JO',
    JP: 'JP',
    KE: 'KE',
    KG: 'KG',
    KH: 'KH',
    KI: 'KI',
    KM: 'KM',
    KN: 'KN',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KY: 'KY',
    KZ: 'KZ',
    LA: 'LA',
    LB: 'LB',
    LC: 'LC',
    LI: 'LI',
    LK: 'LK',
    LR: 'LR',
    LS: 'LS',
    LT: 'LT',
    LU: 'LU',
    LV: 'LV',
    LY: 'LY',
    MA: 'MA',
    MC: 'MC',
    MD: 'MD',
    ME: 'ME',
    MF: 'MF',
    MG: 'MG',
    MH: 'MH',
    MK: 'MK',
    ML: 'ML',
    MM: 'MM',
    MN: 'MN',
    MO: 'MO',
    MP: 'MP',
    MQ: 'MQ',
    MR: 'MR',
    MS: 'MS',
    MT: 'MT',
    MU: 'MU',
    MV: 'MV',
    MW: 'MW',
    MX: 'MX',
    MY: 'MY',
    MZ: 'MZ',
    NA: 'NA',
    NC: 'NC',
    NE: 'NE',
    NF: 'NF',
    NG: 'NG',
    NI: 'NI',
    NL: 'NL',
    NO: 'NO',
    NP: 'NP',
    NR: 'NR',
    NU: 'NU',
    NZ: 'NZ',
    OM: 'OM',
    PA: 'PA',
    PE: 'PE',
    PF: 'PF',
    PG: 'PG',
    PH: 'PH',
    PK: 'PK',
    PL: 'PL',
    PM: 'PM',
    PN: 'PN',
    PR: 'PR',
    PS: 'PS',
    PT: 'PT',
    PW: 'PW',
    PY: 'PY',
    QA: 'QA',
    RE: 'RE',
    RO: 'RO',
    RS: 'RS',
    RU: 'RU',
    RW: 'RW',
    SA: 'SA',
    SB: 'SB',
    SC: 'SC',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SH: 'SH',
    SI: 'SI',
    SJ: 'SJ',
    SK: 'SK',
    SL: 'SL',
    SM: 'SM',
    SN: 'SN',
    SO: 'SO',
    SR: 'SR',
    SS: 'SS',
    ST: 'ST',
    SV: 'SV',
    SX: 'SX',
    SY: 'SY',
    SZ: 'SZ',
    TC: 'TC',
    TD: 'TD',
    TF: 'TF',
    TG: 'TG',
    TH: 'TH',
    TJ: 'TJ',
    TK: 'TK',
    TL: 'TL',
    TM: 'TM',
    TN: 'TN',
    TO: 'TO',
    TR: 'TR',
    TT: 'TT',
    TV: 'TV',
    TW: 'TW',
    TZ: 'TZ',
    UA: 'UA',
    UG: 'UG',
    UM: 'UM',
    US: 'US',
    UY: 'UY',
    UZ: 'UZ',
    VA: 'VA',
    VC: 'VC',
    VE: 'VE',
    VG: 'VG',
    VI: 'VI',
    VN: 'VN',
    VU: 'VU',
    WF: 'WF',
    WS: 'WS',
    YE: 'YE',
    YT: 'YT',
    ZA: 'ZA',
    ZM: 'ZM',
    ZW: 'ZW'
} as const;

export type Country = typeof Country[keyof typeof Country];


/**
 * 
 * @export
 * @interface ErrorErrorsInner
 */
export interface ErrorErrorsInner {
    /**
     * 
     * @type {string}
     * @memberof ErrorErrorsInner
     */
    'code'?: ErrorErrorsInnerCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof ErrorErrorsInner
     */
    'type'?: string;
}

export const ErrorErrorsInnerCodeEnum = {
    _1002: '1002',
    _1003: '1003',
    _1004: '1004',
    _1005: '1005',
    _1006: '1006',
    _1007: '1007',
    _1008: '1008',
    _1009: '1009',
    _1010: '1010',
    _1011: '1011',
    _1012: '1012',
    _1013: '1013',
    _1014: '1014',
    _1015: '1015'
} as const;

export type ErrorErrorsInnerCodeEnum = typeof ErrorErrorsInnerCodeEnum[keyof typeof ErrorErrorsInnerCodeEnum];

/**
 * Format pour la creation d\'un FPS
 * @export
 * @interface FPS
 */
export interface FPS {
    /**
     * 
     * @type {FPSAgent}
     * @memberof FPS
     */
    'agent': FPSAgent;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'authId': string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'authTransfertDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'cityId': string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'fineLegalId': string;
    /**
     * 
     * @type {number}
     * @memberof FPS
     */
    'finePrice': number;
    /**
     * 
     * @type {FPSLicensePlate}
     * @memberof FPS
     */
    'licensePlate': FPSLicensePlate;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'notificationAuthority': FPSNotificationAuthorityEnum;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'notificationDatetime'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'parkId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'parent'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'paymentStatus': FPSPaymentStatusEnum;
    /**
     * 
     * @type {Organization}
     * @memberof FPS
     */
    'recourseOrganization': Organization;
    /**
     * 
     * @type {PersonOrOrganization}
     * @memberof FPS
     */
    'offender'?: PersonOrOrganization;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'reducedDatetime'?: string;
    /**
     * 
     * @type {number}
     * @memberof FPS
     */
    'reducedFinePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'rootFineLegalId'?: string;
    /**
     * 
     * @type {Array<SignificantRight>}
     * @memberof FPS
     */
    'significantRights'?: Array<SignificantRight>;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'statementDatetime': string;
    /**
     * 
     * @type {Location}
     * @memberof FPS
     */
    'statementLocation'?: Location;
    /**
     * 
     * @type {Address}
     * @memberof FPS
     */
    'statementAddress': Address;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'terminalId': string;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'type': FPSTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'validityDatetime': string;
    /**
     * 
     * @type {FPSVehicle}
     * @memberof FPS
     */
    'vehicle': FPSVehicle;
    /**
     * 
     * @type {string}
     * @memberof FPS
     */
    'zoneId': string;
    /**
     * 
     * @type {object}
     * @memberof FPS
     */
    'comments'?: object;
}

export const FPSNotificationAuthorityEnum = {
    LOCAL: 'LOCAL',
    ANTAI: 'ANTAI'
} as const;

export type FPSNotificationAuthorityEnum = typeof FPSNotificationAuthorityEnum[keyof typeof FPSNotificationAuthorityEnum];
export const FPSPaymentStatusEnum = {
    PENDING: 'PENDING',
    PAID: 'PAID',
    OVERPAID: 'OVERPAID'
} as const;

export type FPSPaymentStatusEnum = typeof FPSPaymentStatusEnum[keyof typeof FPSPaymentStatusEnum];
export const FPSTypeEnum = {
    INITIAL: 'INITIAL',
    CORRECTION: 'CORRECTION',
    CANCELLED: 'CANCELLED'
} as const;

export type FPSTypeEnum = typeof FPSTypeEnum[keyof typeof FPSTypeEnum];

/**
 * 
 * @export
 * @interface FPSAgent
 */
export interface FPSAgent {
    /**
     * 
     * @type {string}
     * @memberof FPSAgent
     */
    'agentId': string;
    /**
     * 
     * @type {string}
     * @memberof FPSAgent
     */
    'name': string;
    /**
     * 
     * @type {Organization}
     * @memberof FPSAgent
     */
    'worksFor': Organization;
}
/**
 * 
 * @export
 * @interface FPSLicensePlate
 */
export interface FPSLicensePlate {
    /**
     * 
     * @type {string}
     * @memberof FPSLicensePlate
     */
    'plate': string;
    /**
     * 
     * @type {string}
     * @memberof FPSLicensePlate
     */
    'pricingCategory'?: string;
    /**
     * 
     * @type {Country}
     * @memberof FPSLicensePlate
     */
    'plateCountry': Country;
}
/**
 * 
 * @export
 * @interface FPSVehicle
 */
export interface FPSVehicle {
    /**
     * 
     * @type {string}
     * @memberof FPSVehicle
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof FPSVehicle
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof FPSVehicle
     */
    'vehiculeCategory'?: string;
}
/**
 * 
 * @export
 * @interface FineSearchReq
 */
export interface FineSearchReq {
    /**
     * 
     * @type {FineSearchReqAgent}
     * @memberof FineSearchReq
     */
    'agent'?: FineSearchReqAgent;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'authId'?: string;
    /**
     * 
     * @type {FineSearchReqClaim}
     * @memberof FineSearchReq
     */
    'claim'?: FineSearchReqClaim;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'fineId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'fineLegalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'fineShortId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'rootFineLegalId'?: string;
    /**
     * 
     * @type {number}
     * @memberof FineSearchReq
     */
    'finePrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof FineSearchReq
     */
    'surcharge'?: number;
    /**
     * 
     * @type {FineSearchReqLicensePlate}
     * @memberof FineSearchReq
     */
    'licensePlate'?: FineSearchReqLicensePlate;
    /**
     * 
     * @type {number}
     * @memberof FineSearchReq
     */
    'maxRecords'?: number;
    /**
     * 
     * @type {number}
     * @memberof FineSearchReq
     */
    'offsetLastUpdate'?: number;
    /**
     * 
     * @type {number}
     * @memberof FineSearchReq
     */
    'offsetCreate'?: number;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'notificationAuthority'?: FineSearchReqNotificationAuthorityEnum;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'page'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'parkId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'cityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'parent'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'paymentStatus'?: FineSearchReqPaymentStatusEnum;
    /**
     * 
     * @type {Array<FineSearchReqOrderByInner>}
     * @memberof FineSearchReq
     */
    'orderBy'?: Array<FineSearchReqOrderByInner>;
    /**
     * 
     * @type {Array<FineSearchReqPeriodsInner>}
     * @memberof FineSearchReq
     */
    'periods'?: Array<FineSearchReqPeriodsInner>;
    /**
     * 
     * @type {number}
     * @memberof FineSearchReq
     */
    'reducedFinePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'terminalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'type'?: string;
    /**
     * 
     * @type {FineSearchReqVehicle}
     * @memberof FineSearchReq
     */
    'vehicle'?: FineSearchReqVehicle;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReq
     */
    'zoneId'?: string;
}

export const FineSearchReqNotificationAuthorityEnum = {
    LOCAL: 'LOCAL',
    ANTAI: 'ANTAI'
} as const;

export type FineSearchReqNotificationAuthorityEnum = typeof FineSearchReqNotificationAuthorityEnum[keyof typeof FineSearchReqNotificationAuthorityEnum];
export const FineSearchReqPaymentStatusEnum = {
    PENDING: 'PENDING',
    OVERPAID: 'OVERPAID',
    PAID: 'PAID'
} as const;

export type FineSearchReqPaymentStatusEnum = typeof FineSearchReqPaymentStatusEnum[keyof typeof FineSearchReqPaymentStatusEnum];

/**
 * 
 * @export
 * @interface FineSearchReqAgent
 */
export interface FineSearchReqAgent {
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqAgent
     */
    'agentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqAgent
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface FineSearchReqClaim
 */
export interface FineSearchReqClaim {
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqClaim
     */
    'claimStatus'?: FineSearchReqClaimClaimStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqClaim
     */
    'claimType'?: FineSearchReqClaimClaimTypeEnum;
}

export const FineSearchReqClaimClaimStatusEnum = {
    FILLED: 'FILLED',
    REJECTED: 'REJECTED',
    TRANSFERRED: 'TRANSFERRED',
    ACCEPTED: 'ACCEPTED'
} as const;

export type FineSearchReqClaimClaimStatusEnum = typeof FineSearchReqClaimClaimStatusEnum[keyof typeof FineSearchReqClaimClaimStatusEnum];
export const FineSearchReqClaimClaimTypeEnum = {
    PRELIMINARY: 'PRELIMINARY',
    REGULATORY: 'REGULATORY'
} as const;

export type FineSearchReqClaimClaimTypeEnum = typeof FineSearchReqClaimClaimTypeEnum[keyof typeof FineSearchReqClaimClaimTypeEnum];

/**
 * 
 * @export
 * @interface FineSearchReqLicensePlate
 */
export interface FineSearchReqLicensePlate {
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqLicensePlate
     */
    'plate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqLicensePlate
     */
    'plateCountry'?: string;
}
/**
 * 
 * @export
 * @interface FineSearchReqOrderByInner
 */
export interface FineSearchReqOrderByInner {
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqOrderByInner
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqOrderByInner
     */
    'sort'?: FineSearchReqOrderByInnerSortEnum;
}

export const FineSearchReqOrderByInnerSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC',
    asc: 'asc',
    desc: 'desc'
} as const;

export type FineSearchReqOrderByInnerSortEnum = typeof FineSearchReqOrderByInnerSortEnum[keyof typeof FineSearchReqOrderByInnerSortEnum];

/**
 * 
 * @export
 * @interface FineSearchReqPeriodsInner
 */
export interface FineSearchReqPeriodsInner {
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqPeriodsInner
     */
    'endDatetime'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqPeriodsInner
     */
    'startDatetime'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqPeriodsInner
     */
    'type'?: FineSearchReqPeriodsInnerTypeEnum;
}

export const FineSearchReqPeriodsInnerTypeEnum = {
    STATEMENT: 'STATEMENT',
    MODIFICATION: 'MODIFICATION',
    VALIDITY: 'VALIDITY',
    REDUCED: 'REDUCED',
    CANCELLED: 'CANCELLED',
    CREATION: 'CREATION',
    TRANSFERT_ANTAI: 'TRANSFERT_ANTAI',
    PAYMENT: 'PAYMENT'
} as const;

export type FineSearchReqPeriodsInnerTypeEnum = typeof FineSearchReqPeriodsInnerTypeEnum[keyof typeof FineSearchReqPeriodsInnerTypeEnum];

/**
 * 
 * @export
 * @interface FineSearchReqVehicle
 */
export interface FineSearchReqVehicle {
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqVehicle
     */
    'brand'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineSearchReqVehicle
     */
    'model'?: string;
}
/**
 * 
 * @export
 * @interface FineSearchRes
 */
export interface FineSearchRes {
    /**
     * 
     * @type {number}
     * @memberof FineSearchRes
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof FineSearchRes
     */
    'nextPage'?: number;
    /**
     * 
     * @type {Array<FPS>}
     * @memberof FineSearchRes
     */
    'matches'?: Array<FPS>;
}
/**
 * Format pour le calcul du montant d\'un FPS
 * @export
 * @interface FineValueReq
 */
export interface FineValueReq {
    /**
     * 
     * @type {string}
     * @memberof FineValueReq
     */
    'authId': string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReq
     */
    'cityId': string;
    /**
     * 
     * @type {FineValueReqLicensePlate}
     * @memberof FineValueReq
     */
    'licensePlate': FineValueReqLicensePlate;
    /**
     * 
     * @type {string}
     * @memberof FineValueReq
     */
    'parkId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReq
     */
    'statementDatetime': string;
    /**
     * 
     * @type {Array<FineValueReqTicketsInner>}
     * @memberof FineValueReq
     */
    'tickets'?: Array<FineValueReqTicketsInner>;
    /**
     * 
     * @type {FineValueReqVehicle}
     * @memberof FineValueReq
     */
    'vehicle': FineValueReqVehicle;
    /**
     * 
     * @type {string}
     * @memberof FineValueReq
     */
    'zoneId': string;
}
/**
 * 
 * @export
 * @interface FineValueReqLicensePlate
 */
export interface FineValueReqLicensePlate {
    /**
     * 
     * @type {string}
     * @memberof FineValueReqLicensePlate
     */
    'plate': string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqLicensePlate
     */
    'plateCountry': string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqLicensePlate
     */
    'pricingCategory'?: string;
}
/**
 * 
 * @export
 * @interface FineValueReqTicketsInner
 */
export interface FineValueReqTicketsInner {
    /**
     * 
     * @type {string}
     * @memberof FineValueReqTicketsInner
     */
    'cityId': string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqTicketsInner
     */
    'endDatetime': string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqTicketsInner
     */
    'parkId'?: string;
    /**
     * 
     * @type {number}
     * @memberof FineValueReqTicketsInner
     */
    'rightPrice': number;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqTicketsInner
     */
    'startDatetime': string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqTicketsInner
     */
    'type': FineValueReqTicketsInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqTicketsInner
     */
    'zoneId'?: string;
}

export const FineValueReqTicketsInnerTypeEnum = {
    FINE: 'FINE',
    TICKET: 'TICKET',
    CONTRACT: 'CONTRACT',
    FREE: 'FREE',
    OTHER: 'OTHER'
} as const;

export type FineValueReqTicketsInnerTypeEnum = typeof FineValueReqTicketsInnerTypeEnum[keyof typeof FineValueReqTicketsInnerTypeEnum];

/**
 * 
 * @export
 * @interface FineValueReqVehicle
 */
export interface FineValueReqVehicle {
    /**
     * 
     * @type {string}
     * @memberof FineValueReqVehicle
     */
    'brand': string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqVehicle
     */
    'model'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineValueReqVehicle
     */
    'vehiculeCategory'?: string;
}
/**
 * 
 * @export
 * @interface FineValueRes
 */
export interface FineValueRes {
    /**
     * 
     * @type {string}
     * @memberof FineValueRes
     */
    'statementDatetime'?: string;
    /**
     * 
     * @type {string}
     * @memberof FineValueRes
     */
    'validityDatetime'?: string;
    /**
     * 
     * @type {number}
     * @memberof FineValueRes
     */
    'finePrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof FineValueRes
     */
    'reducedFinePrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof FineValueRes
     */
    'reducedDatetime'?: string;
    /**
     * 
     * @type {Array<SignificantRight>}
     * @memberof FineValueRes
     */
    'significantRights'?: Array<SignificantRight>;
}
/**
 * 
 * @export
 * @interface FpsId
 */
export interface FpsId {
    /**
     * 
     * @type {string}
     * @memberof FpsId
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'longitude': number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'altitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Location
     */
    'incertitude'?: number;
}
/**
 * 
 * @export
 * @interface Media
 */
export interface Media {
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    'matricule'?: string;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    'filename'?: string;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    'fineLegalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Media
     */
    'fineId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Media
     */
    'accuracy'?: number;
    /**
     * photo encodée en base64
     * @type {string}
     * @memberof Media
     */
    'photo'?: string;
    /**
     * 
     * @type {number}
     * @memberof Media
     */
    'longitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Media
     */
    'latitude'?: number;
}
/**
 * 
 * @export
 * @interface MediaError
 */
export interface MediaError {
    /**
     * 
     * @type {string}
     * @memberof MediaError
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {Array<ErrorErrorsInner>}
     * @memberof ModelError
     */
    'errors'?: Array<ErrorErrorsInner>;
}
/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'url'?: string;
    /**
     * 
     * @type {AddressOrganization}
     * @memberof Organization
     */
    'address': AddressOrganization;
}
/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'gender': PersonGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'honorificPrefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'givenName': string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'additionalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'maidenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    'familyName': string;
    /**
     * 
     * @type {AddressIndebted}
     * @memberof Person
     */
    'address': AddressIndebted;
}

export const PersonGenderEnum = {
    MALE: 'MALE',
    FEMALE: 'FEMALE'
} as const;

export type PersonGenderEnum = typeof PersonGenderEnum[keyof typeof PersonGenderEnum];

/**
 * 
 * @export
 * @interface PersonOrOrganization
 */
export interface PersonOrOrganization {
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'organizationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'gender'?: PersonOrOrganizationGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'honorificPrefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'additionalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'maidenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOrOrganization
     */
    'familyName'?: string;
    /**
     * 
     * @type {AddressIndebtedOrganization}
     * @memberof PersonOrOrganization
     */
    'address': AddressIndebtedOrganization;
}

export const PersonOrOrganizationGenderEnum = {
    MALE: 'MALE',
    FEMALE: 'FEMALE'
} as const;

export type PersonOrOrganizationGenderEnum = typeof PersonOrOrganizationGenderEnum[keyof typeof PersonOrOrganizationGenderEnum];

/**
 * 
 * @export
 * @interface SignificantRight
 */
export interface SignificantRight {
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'type': SignificantRightTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'cityId': string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'endDatetime': string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'fineId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'fineLegalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'parkId'?: string;
    /**
     * 
     * @type {number}
     * @memberof SignificantRight
     */
    'rightPrice': number;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'rootFineLegalId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'startDatetime': string;
    /**
     * 
     * @type {string}
     * @memberof SignificantRight
     */
    'zoneId'?: string;
}

export const SignificantRightTypeEnum = {
    FINE: 'FINE',
    TICKET: 'TICKET',
    CONTRACT: 'CONTRACT',
    FREE: 'FREE',
    OTHER: 'OTHER'
} as const;

export type SignificantRightTypeEnum = typeof SignificantRightTypeEnum[keyof typeof SignificantRightTypeEnum];


/**
 * FpsApi - axios parameter creator
 * @export
 */
export const FpsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Calcul du montant du FPS
         * @param {string} cityId siret de la ville
         * @param {FineValueReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calcFPS: async (cityId: string, body: FineValueReq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('calcFPS', 'cityId', cityId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('calcFPS', 'body', body)
            const localVarPath = `/api/v1/{cityId}/fine-values`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Récupération du dernier id du fps de l\'agent pour une date donnée
         * @param {string} cityId siret de la ville
         * @param {string} organisationid 
         * @param {string} [matricule] matricule de l\&#39;agent
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastId: async (cityId: string, organisationid: string, matricule?: string, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('getLastId', 'cityId', cityId)
            // verify required parameter 'organisationid' is not null or undefined
            assertParamExists('getLastId', 'organisationid', organisationid)
            const localVarPath = `/api/v1/{cityId}/lastid`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)

            if (matricule !== undefined) {
                localVarQueryParameter['matricule'] = matricule;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (organisationid !== undefined) {
                localVarQueryParameter['organisationid'] = organisationid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Récupération du deriner id de la journée
         * @param {string} cityId siret de la ville
         * @param {string} organisationid 
         * @param {string} [matricule] matricule de l\&#39;agent
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextId: async (cityId: string, organisationid: string, matricule?: string, date?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('getNextId', 'cityId', cityId)
            // verify required parameter 'organisationid' is not null or undefined
            assertParamExists('getNextId', 'organisationid', organisationid)
            const localVarPath = `/api/v1/{cityId}/nextid`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)

            if (matricule !== undefined) {
                localVarQueryParameter['matricule'] = matricule;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (organisationid !== undefined) {
                localVarQueryParameter['organisationid'] = organisationid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Recherche de FPS
         * @param {string} cityId siret de la ville
         * @param {FineSearchReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFPS: async (cityId: string, body: FineSearchReq, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('searchFPS', 'cityId', cityId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('searchFPS', 'body', body)
            const localVarPath = `/api/v1/{cityId}/fines-search`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Seuls les champs suivants ne peuvent pas s\'y trouver &#58;<br/> – \"dateModified\" et \"fineId\" car ils sont assignés par le serveur de FPS <br/> – \"payments\", \"debtCollectionDatetime\" et \"CancelDatetime\" car ce sont des champs qui sont ajoutés sur un FPS déjà créé.<br/> – \"claims\" dans le cas d’un FPS initial.<br/> Il est en revanche obligatoire que le champ fineLegalId s\'y trouve puisqu\'il est de la charge de celui qui demande l\'enregistrement du FPS de générer ce numéro. Le caractère obligatoire des autres champs est décrit dans la structure du FPS et dépend également du contexte.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Enregistrement du FPS par le serveur de FPS
         * @param {string} cityId siret de la ville
         * @param {FPS} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFPS: async (cityId: string, body?: FPS, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('sendFPS', 'cityId', cityId)
            const localVarPath = `/api/v1/{cityId}/fines`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FpsApi - functional programming interface
 * @export
 */
export const FpsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FpsApiAxiosParamCreator(configuration)
    return {
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Calcul du montant du FPS
         * @param {string} cityId siret de la ville
         * @param {FineValueReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calcFPS(cityId: string, body: FineValueReq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FineValueRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calcFPS(cityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Récupération du dernier id du fps de l\'agent pour une date donnée
         * @param {string} cityId siret de la ville
         * @param {string} organisationid 
         * @param {string} [matricule] matricule de l\&#39;agent
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastId(cityId: string, organisationid: string, matricule?: string, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FpsId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastId(cityId, organisationid, matricule, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Récupération du deriner id de la journée
         * @param {string} cityId siret de la ville
         * @param {string} organisationid 
         * @param {string} [matricule] matricule de l\&#39;agent
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextId(cityId: string, organisationid: string, matricule?: string, date?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FpsId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextId(cityId, organisationid, matricule, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Recherche de FPS
         * @param {string} cityId siret de la ville
         * @param {FineSearchReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchFPS(cityId: string, body: FineSearchReq, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FineSearchRes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchFPS(cityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Seuls les champs suivants ne peuvent pas s\'y trouver &#58;<br/> – \"dateModified\" et \"fineId\" car ils sont assignés par le serveur de FPS <br/> – \"payments\", \"debtCollectionDatetime\" et \"CancelDatetime\" car ce sont des champs qui sont ajoutés sur un FPS déjà créé.<br/> – \"claims\" dans le cas d’un FPS initial.<br/> Il est en revanche obligatoire que le champ fineLegalId s\'y trouve puisqu\'il est de la charge de celui qui demande l\'enregistrement du FPS de générer ce numéro. Le caractère obligatoire des autres champs est décrit dans la structure du FPS et dépend également du contexte.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Enregistrement du FPS par le serveur de FPS
         * @param {string} cityId siret de la ville
         * @param {FPS} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendFPS(cityId: string, body?: FPS, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FPS>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendFPS(cityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FpsApi - factory interface
 * @export
 */
export const FpsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FpsApiFp(configuration)
    return {
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Calcul du montant du FPS
         * @param {string} cityId siret de la ville
         * @param {FineValueReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calcFPS(cityId: string, body: FineValueReq, options?: any): AxiosPromise<FineValueRes> {
            return localVarFp.calcFPS(cityId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Récupération du dernier id du fps de l\'agent pour une date donnée
         * @param {string} cityId siret de la ville
         * @param {string} organisationid 
         * @param {string} [matricule] matricule de l\&#39;agent
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastId(cityId: string, organisationid: string, matricule?: string, date?: string, options?: any): AxiosPromise<FpsId> {
            return localVarFp.getLastId(cityId, organisationid, matricule, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Récupération du deriner id de la journée
         * @param {string} cityId siret de la ville
         * @param {string} organisationid 
         * @param {string} [matricule] matricule de l\&#39;agent
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextId(cityId: string, organisationid: string, matricule?: string, date?: string, options?: any): AxiosPromise<FpsId> {
            return localVarFp.getNextId(cityId, organisationid, matricule, date, options).then((request) => request(axios, basePath));
        },
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Recherche de FPS
         * @param {string} cityId siret de la ville
         * @param {FineSearchReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFPS(cityId: string, body: FineSearchReq, options?: any): AxiosPromise<FineSearchRes> {
            return localVarFp.searchFPS(cityId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Seuls les champs suivants ne peuvent pas s\'y trouver &#58;<br/> – \"dateModified\" et \"fineId\" car ils sont assignés par le serveur de FPS <br/> – \"payments\", \"debtCollectionDatetime\" et \"CancelDatetime\" car ce sont des champs qui sont ajoutés sur un FPS déjà créé.<br/> – \"claims\" dans le cas d’un FPS initial.<br/> Il est en revanche obligatoire que le champ fineLegalId s\'y trouve puisqu\'il est de la charge de celui qui demande l\'enregistrement du FPS de générer ce numéro. Le caractère obligatoire des autres champs est décrit dans la structure du FPS et dépend également du contexte.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
         * @summary Enregistrement du FPS par le serveur de FPS
         * @param {string} cityId siret de la ville
         * @param {FPS} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFPS(cityId: string, body?: FPS, options?: any): AxiosPromise<FPS> {
            return localVarFp.sendFPS(cityId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FpsApi - interface
 * @export
 * @interface FpsApi
 */
export interface FpsApiInterface {
    /**
     * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Calcul du montant du FPS
     * @param {string} cityId siret de la ville
     * @param {FineValueReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    calcFPS(cityId: string, body: FineValueReq, options?: AxiosRequestConfig): AxiosPromise<FineValueRes>;

    /**
     * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Récupération du dernier id du fps de l\'agent pour une date donnée
     * @param {string} cityId siret de la ville
     * @param {string} organisationid 
     * @param {string} [matricule] matricule de l\&#39;agent
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    getLastId(cityId: string, organisationid: string, matricule?: string, date?: string, options?: AxiosRequestConfig): AxiosPromise<FpsId>;

    /**
     * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Récupération du deriner id de la journée
     * @param {string} cityId siret de la ville
     * @param {string} organisationid 
     * @param {string} [matricule] matricule de l\&#39;agent
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    getNextId(cityId: string, organisationid: string, matricule?: string, date?: string, options?: AxiosRequestConfig): AxiosPromise<FpsId>;

    /**
     * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Recherche de FPS
     * @param {string} cityId siret de la ville
     * @param {FineSearchReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    searchFPS(cityId: string, body: FineSearchReq, options?: AxiosRequestConfig): AxiosPromise<FineSearchRes>;

    /**
     * Seuls les champs suivants ne peuvent pas s\'y trouver &#58;<br/> – \"dateModified\" et \"fineId\" car ils sont assignés par le serveur de FPS <br/> – \"payments\", \"debtCollectionDatetime\" et \"CancelDatetime\" car ce sont des champs qui sont ajoutés sur un FPS déjà créé.<br/> – \"claims\" dans le cas d’un FPS initial.<br/> Il est en revanche obligatoire que le champ fineLegalId s\'y trouve puisqu\'il est de la charge de celui qui demande l\'enregistrement du FPS de générer ce numéro. Le caractère obligatoire des autres champs est décrit dans la structure du FPS et dépend également du contexte.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Enregistrement du FPS par le serveur de FPS
     * @param {string} cityId siret de la ville
     * @param {FPS} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    sendFPS(cityId: string, body?: FPS, options?: AxiosRequestConfig): AxiosPromise<FPS>;

}

/**
 * FpsApi - object-oriented interface
 * @export
 * @class FpsApi
 * @extends {BaseAPI}
 */
export class FpsApi extends BaseAPI implements FpsApiInterface {
    /**
     * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Calcul du montant du FPS
     * @param {string} cityId siret de la ville
     * @param {FineValueReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApi
     */
    public calcFPS(cityId: string, body: FineValueReq, options?: AxiosRequestConfig) {
        return FpsApiFp(this.configuration).calcFPS(cityId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Récupération du dernier id du fps de l\'agent pour une date donnée
     * @param {string} cityId siret de la ville
     * @param {string} organisationid 
     * @param {string} [matricule] matricule de l\&#39;agent
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApi
     */
    public getLastId(cityId: string, organisationid: string, matricule?: string, date?: string, options?: AxiosRequestConfig) {
        return FpsApiFp(this.configuration).getLastId(cityId, organisationid, matricule, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Le matricule est optionnel si le token renseigné est de type agent. En cas d\'absence de date la date courante est utilisée. Le token doit comporter le role <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Récupération du deriner id de la journée
     * @param {string} cityId siret de la ville
     * @param {string} organisationid 
     * @param {string} [matricule] matricule de l\&#39;agent
     * @param {string} [date] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApi
     */
    public getNextId(cityId: string, organisationid: string, matricule?: string, date?: string, options?: AxiosRequestConfig) {
        return FpsApiFp(this.configuration).getNextId(cityId, organisationid, matricule, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Recherche de FPS
     * @param {string} cityId siret de la ville
     * @param {FineSearchReq} body Calcul du FPS à partir des informations dont les données sont incluses dans le contenu de la requête
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApi
     */
    public searchFPS(cityId: string, body: FineSearchReq, options?: AxiosRequestConfig) {
        return FpsApiFp(this.configuration).searchFPS(cityId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Seuls les champs suivants ne peuvent pas s\'y trouver &#58;<br/> – \"dateModified\" et \"fineId\" car ils sont assignés par le serveur de FPS <br/> – \"payments\", \"debtCollectionDatetime\" et \"CancelDatetime\" car ce sont des champs qui sont ajoutés sur un FPS déjà créé.<br/> – \"claims\" dans le cas d’un FPS initial.<br/> Il est en revanche obligatoire que le champ fineLegalId s\'y trouve puisqu\'il est de la charge de celui qui demande l\'enregistrement du FPS de générer ce numéro. Le caractère obligatoire des autres champs est décrit dans la structure du FPS et dépend également du contexte.<br/> Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_FPS</b></il> </ul>
     * @summary Enregistrement du FPS par le serveur de FPS
     * @param {string} cityId siret de la ville
     * @param {FPS} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApi
     */
    public sendFPS(cityId: string, body?: FPS, options?: AxiosRequestConfig) {
        return FpsApiFp(this.configuration).sendFPS(cityId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_ANNEXE</b></il> </ul>
         * @summary Ajout d\'une photo
         * @param {string} cityId siret de la ville
         * @param {Media} [body] Media
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPicture: async (cityId: string, body?: Media, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('addPicture', 'cityId', cityId)
            const localVarPath = `/api/v1/{cityId}/media`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "x-bearer-token", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration)
    return {
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_ANNEXE</b></il> </ul>
         * @summary Ajout d\'une photo
         * @param {string} cityId siret de la ville
         * @param {Media} [body] Media
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPicture(cityId: string, body?: Media, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPicture(cityId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MediaApiFp(configuration)
    return {
        /**
         * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_ANNEXE</b></il> </ul>
         * @summary Ajout d\'une photo
         * @param {string} cityId siret de la ville
         * @param {Media} [body] Media
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPicture(cityId: string, body?: Media, options?: any): AxiosPromise<void> {
            return localVarFp.addPicture(cityId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MediaApi - interface
 * @export
 * @interface MediaApi
 */
export interface MediaApiInterface {
    /**
     * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_ANNEXE</b></il> </ul>
     * @summary Ajout d\'une photo
     * @param {string} cityId siret de la ville
     * @param {Media} [body] Media
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApiInterface
     */
    addPicture(cityId: string, body?: Media, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI implements MediaApiInterface {
    /**
     * Les droits necessaires dans le JWT sont  &#58; <ul> <il><b>ROLE_PC_ANNEXE</b></il> </ul>
     * @summary Ajout d\'une photo
     * @param {string} cityId siret de la ville
     * @param {Media} [body] Media
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaApi
     */
    public addPicture(cityId: string, body?: Media, options?: AxiosRequestConfig) {
        return MediaApiFp(this.configuration).addPicture(cityId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


